import React, { CSSProperties, ReactElement } from 'react';
import url from 'url';

import styles from '../assets/styles/projects.module.scss';
import { server } from '../const/axios';

export default class ImageBox extends React.Component<{
	image: string
	style: CSSProperties
}> {

	get defaultStyle() {
		let image = url.resolve(server + '/artwork/', this.props.image);
		return {
			backgroundColor: 'black',
			backgroundImage: `url(${image})`,
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat'
		} as CSSProperties;
	}

	render(): ReactElement {
		let style = Object.assign(this.defaultStyle, this.props.style);
		return (
			<div
				className={[styles.imageBox, styles['project-text']].join(' ')}
				style={style}
			/>
		);
	}
}